var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Instagram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.6 20.6",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Gruppe_379",
    transform: "translate(-80.489 -545.527)",
    d: "M95.2,566.1h-8.9c-3.2,0-5.9-2.6-5.9-5.9v-8.9 c0-3.2,2.6-5.9,5.9-5.9h8.9c3.2,0,5.9,2.6,5.9,5.9v8.9C101.1,563.5,98.5,566.1,95.2,566.1z M86.4,547.3c-2.3,0-4.1,1.8-4.1,4.1v8.9 c0,2.3,1.8,4.1,4.1,4.1h8.9c2.3,0,4.1-1.8,4.1-4.1v-8.9c0-2.3-1.8-4.1-4.1-4.1H86.4z M90.8,560.9c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5 s5,2.2,5,5l0,0C95.8,558.7,93.6,560.9,90.8,560.9z M90.8,552.6c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3 C94.1,554.1,92.6,552.6,90.8,552.6z M97.8,550.3c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h0 C97.1,548.7,97.8,549.4,97.8,550.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.a496d108c5f903c215e0eecf0c6f96b6.svg";
export { ForwardRef as ReactComponent };